import { inject, Injectable } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { VersionCheckerComponent } from './version-checker.component';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';

interface IVersionDetails {
  app: string;
  build: number;
  required: boolean;
}
@Injectable({
  providedIn: 'root'
})
export class VersionCheckerService {

  private readonly appName = "psp"; // <- cambiar esto por el nombre del app en el JSON de versiones
  private checked: boolean;
  private modalCtrl = inject(ModalController);
  private alertCtrl = inject(AlertController);
  private httpClient = inject(HttpClient);

  public async checkVersion() {
    if(this.checked) return;
    const { shouldUpdate, forceUpdate} = await this.checkUpdate();
    if(!shouldUpdate) return;
    await new Promise(resolve => setTimeout(resolve, 1000));
    await this.dismissAllAlerts();
    const modal = await this.modalCtrl.create({
    component: VersionCheckerComponent,
      componentProps: {
        forceUpdate
      }
    });
    await modal.present();
    this.checked = true;
  }

  private async dismissAllAlerts(): Promise<void> {
    let alert = await this.alertCtrl.getTop();
    while (alert) {
      await alert.dismiss();
      alert = await this.alertCtrl.getTop();
    }
  }

  private async checkUpdate(): Promise<{shouldUpdate: boolean; forceUpdate: boolean}> {
    const id = window.crypto.randomUUID();
    const res = await firstValueFrom(this.httpClient.get<IVersionDetails[]>(`https://api.lancergroup.org/apps_build_config.json?id=${id}`));
    const data = res.find((d) => d.app === this.appName);
    if(data === undefined) return {shouldUpdate: false, forceUpdate: false};
    const {build} =  await App.getInfo();
    return {shouldUpdate: data.build > +build, forceUpdate: data.required}
  }
}
